import { Component, PropSync, Vue } from "vue-property-decorator";
import Cookies from 'js-cookie';

import { UserInfo } from "@/types";
import { Network } from "@/network";
import { PermissionCode, DefaultPath } from "@/constant/GroupPermission";

import { TCBReceiptApi } from "@/network/pb/proto";
import { Priv } from "@/util/Priv";

import { LoginModel } from "@/models/LoginModel";

import { LightBoxConfirm, Hint } from "@/components";
import { Common } from "@/constant";

@Component<Nav>({
  components: {
    LightBoxConfirm,
    Hint,
  }
})
export default class Nav extends Vue {
  @PropSync("expireTime", { type: Number })
  syncedExpireTime!: number;

  /* 展期計時器 */
  private remainTime = "";
  private intervalClock!: null | ReturnType<typeof setInterval>;
  /* 展期計時器 */

  private tidNumber = "";
  private menuShow: {
    account: boolean,
    accountEdit: boolean,
    announcement: boolean,
    reimbursement: boolean,
    appropriation: boolean,
    deposit: boolean,
    report: boolean,
  } = {
    account: false,
    accountEdit: false,
    announcement: false,
    reimbursement: false,
    appropriation: false,
    deposit: false,
    report: false,
  };

  /* LightBoxConfirm */
  private lightBoxConfirmInfo: {
    show: boolean,
    title: string,
    txt: string,
    cancel: string,
    confirm: string
  } = {
    show:false,
    title: "",
    txt: "",
    cancel: "",
    confirm: ""
  };
  /* LightBoxConfirm */

  /* Hint */
  private hintBox: { show: boolean, hint: string } = { show: false, hint: "" };
  /* Hint */
  public async created() {
    const userInfo: UserInfo = JSON.parse(Cookies.get("appUserInfo") as string);
    if (userInfo && userInfo.identification) {
      this.tidNumber = userInfo.identification as string;
    }

    this.setMenuPriv(); // priv
    this.setClock(0);
  }

  public beforeDestroy() {
    if (this.intervalClock) {
      clearInterval(this.intervalClock as ReturnType<typeof setInterval>);
    }
  }

  /* priv */
  private setMenuPriv() {
    if (!Cookies.get("appUserAuthPrivJson")) {
      return false;
    }

    // 更新權限
    const menuPriv = JSON.parse(Cookies.get("appUserAuthPrivJson") as string) as { [k: string]: TCBReceiptApi.Protobuf.IGroupMap };
    console.log(menuPriv);

    // account
    // 使用管理者帳號導入列表，非管理者帳號則導入編輯內頁
    const isAdmin = Cookies.get("isAdmin") as string;
    if (isAdmin === undefined) {
      this.menuShow.accountEdit = true;
    } else if (isAdmin === '1') {
      if (menuPriv[(PermissionCode.BankStore)]) {
        const controllerMenu = menuPriv[(PermissionCode.BankStore)].map as { [k:string]: TCBReceiptApi.Protobuf.Permission };
        if (controllerMenu[(PermissionCode.BankStoreUser)] && controllerMenu[(PermissionCode.BankStoreUser)].get === 1) {
          this.menuShow.account = true;
        }
      }
    }

    // announcement
    this.menuShow.announcement = true;
    
    // reimbursement
    if (menuPriv[(PermissionCode.BankReconciliation)]) {
      const controllerMenu = menuPriv[(PermissionCode.BankReconciliation)].map as { [k:string]: TCBReceiptApi.Protobuf.Permission };
      if (controllerMenu[(PermissionCode.BankReconciliationReimbursement)] && controllerMenu[(PermissionCode.BankReconciliationReimbursement)].get === 1) {
        this.menuShow.reimbursement = true;
      }
    }

    // appropriation
    if (menuPriv[(PermissionCode.BankReconciliation)]) {
      const controllerMenu = menuPriv[(PermissionCode.BankReconciliation)].map as { [k:string]: TCBReceiptApi.Protobuf.Permission };
      if (controllerMenu[(PermissionCode.BankReconciliationDeposit)] && controllerMenu[(PermissionCode.BankReconciliationDeposit)].get === 1) {
        this.menuShow.appropriation = true;
      }
    }
    
    // deposit
    if (menuPriv[(PermissionCode.BankReconciliation)]) {
      const controllerMenu = menuPriv[(PermissionCode.BankReconciliation)].map as { [k:string]: TCBReceiptApi.Protobuf.Permission };
      if (controllerMenu[(PermissionCode.BankReconciliationAppropriation)] && controllerMenu[(PermissionCode.BankReconciliationAppropriation)].get === 1) {
        this.menuShow.deposit = true;
      }
    }

    // report
    if (menuPriv[(PermissionCode.BankReconciliation)]) {
      const controllerMenu = menuPriv[(PermissionCode.BankReconciliation)].map as { [k:string]: TCBReceiptApi.Protobuf.Permission };
      if (controllerMenu[(PermissionCode.BankReconciliationReport)] && controllerMenu[(PermissionCode.BankReconciliationReport)].get === 1) {
        this.menuShow.report = true;
      }
    }
  }
  /* priv */

  private async logout() {
    if (window.location.href !== process.env.VUE_APP_BASE_URL + "/login") {
      await LoginModel.logout();
    
      Network.removeToken();
      Cookies.remove("appToken");
      Cookies.remove("appUserAuthPrivJson");
      Cookies.remove("loginType");
      Cookies.remove("e2eeFlag");
      Cookies.remove("appUserInfo");
      Cookies.remove("isAdmin");

      // this.$router.push("/login");
      window.location.href = '/login';
    }
  }

  private async sepower() {
    window.open("https://neinv.tradevan.com.tw/tln-bin/APTLN/neinv.do");
  }
 
  /* LightBoxConfirm */
  private openLightBoxConfirm() {
    this.lightBoxConfirmInfo.show = true;
    this.lightBoxConfirmInfo.title = "親愛的客戶 您好，";
    this.lightBoxConfirmInfo.txt = "提醒您未使用時間已超過本系統時限，為保障您的資料安全，<br>系統將於 <span style='color:red;'>" + this.remainTime +"秒</span> 後自動登出，請確認是否繼續使用：";
    this.lightBoxConfirmInfo.cancel = "我要登出";
    this.lightBoxConfirmInfo.confirm = "繼續使用";
  }

  private closeLightBoxConfirm() {
    this.lightBoxConfirmInfo.show = false;

    if (this.intervalClock) {
      clearInterval(this.intervalClock as ReturnType<typeof setInterval>);
    }

    this.logout();
  }

  private async confirmLightBoxConfirm() {
    this.lightBoxConfirmInfo.show = false;
    clearInterval(this.intervalClock as ReturnType<typeof setInterval>);
    
    // 展期延長至時間上限
    const [errorCode, expireTime]:[TCBReceiptApi.Protobuf.ErrorCode, number] = await LoginModel.CheckAndUpdateAndGetOnline();

    if (errorCode !== TCBReceiptApi.Protobuf.ErrorCode.EC_SUCESS) {
      this.openHint(Common.ErrorCodeMap[errorCode]);
      return false;
    } else {
      /* 展期計時器 */
      this.setClock(expireTime);
      /* 展期計時器 */
    }
  }
  /* LightBoxConfirm */

  /* Hint */
  private openHint(hint: string) {
    this.hintBox.show = true;
    this.hintBox.hint = hint;
  }

  private closeHint() {
    this.hintBox.show = false;
    this.hintBox.hint = "";
    this.logout();
  }
  /* Hint */  
  private async waitforsyncedExpireTime():Promise<void>{
    while(!this.syncedExpireTime||this.syncedExpireTime===0){
      await new Promise(resolve => setTimeout(resolve,1000))
    }
  }
  private async setClock(expireTime: number) {
    await this.waitforsyncedExpireTime();//若沒有取得this.syncedExpireTime就執行迴圈等待取值
    this.intervalClock = setInterval(() => {
      const nowUnixTime = +new Date();
      const nowCleanUnixTime = nowUnixTime - nowUnixTime % 1000;
      let remainTime = 0;
      if (expireTime > 0) {
        remainTime = expireTime - (nowCleanUnixTime / 1000);
      } else {
        remainTime = this.syncedExpireTime - (nowCleanUnixTime / 1000);
      }
      this.remainTime = remainTime.toString();

      if (remainTime > 0 && remainTime <= 180) { // 秒數小於規定值 跳出提示 是否延長展期
        this.openLightBoxConfirm();
      } else if (remainTime <= 0) {
        this.lightBoxConfirmInfo.show = false;

        if (this.intervalClock) {
          clearInterval(this.intervalClock as ReturnType<typeof setInterval>);
        }
    
        this.openHint("您已被登出");
      }
    }, 1000);
  }
}
